export default function ({ store, redirect, route }) {
    // If the user is not authenticated
    if (store.state.auth.loggedIn && !route.query.secret && !route.query.punchouttoken) {
        return redirect('/');
    }
}
